import { RequireAuth } from '../features/auth/RequireAuth';
import { AppFrame } from './AppFrame';

/**
 * Layout for the authenticated app section (`/app/*`): gate on a session, then
 * render the App-Mode shell (which provides the nav and an Outlet for the
 * per-section screens).
 */
export function AppLayout() {
  return (
    <RequireAuth>
      <AppFrame />
    </RequireAuth>
  );
}
